@if (productMenuService.childTabs(); as childTabs) {
    <div [ngClass]="'items-' + childTabs.length" class="product-menu-tabs">
        @for (item of childTabs; track trackByText($index, item)) {
            @if (useFastIconType && item.type !== 'icon') {
                <vn-menu-item
                    [item]="item"
                    [section]="MenuSection.ProductMenuTop"
                    (onClick)="onClick(item)"
                    [displayMode]="MenuDisplayMode.FastIcon"
                    badgePosition="FastIcon" />
            } @else {
                <vn-menu-item
                    [item]="item"
                    [section]="MenuSection.ProductMenuTop"
                    (onClick)="onClick(item)"
                    [displayMode]="MenuDisplayMode.Icon"
                    badgePosition="icon" />
            }
        }
    </div>
}
